
module.exports = function getResource(label, vars = []) {
    const resources = {
        shopFaves: 'Dénichez parmi vos favoris',
        viewAll: 'Tout afficher',
        fromLovesList: 'De votre liste de favoris...'
    };
    return resources[label];
};
